(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'LivePlannerRequestConsultation',
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.LivePlannerParticipants.init(form.name);

		Adzuki.CharacterCount('#liveplannerrequestconsultation-comments', {
			max  : 255,
			label: '#client-notes-count',
		});
	};
}(jQuery, window.Adzuki || {}));
